import { render, staticRenderFns } from "./PluginContainer.vue?vue&type=template&id=0738a6fc"
import script from "./PluginContainer.vue?vue&type=script&lang=js"
export * from "./PluginContainer.vue?vue&type=script&lang=js"
import style0 from "./PluginContainer.vue?vue&type=style&index=0&id=0738a6fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports